import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { __ } from "@jti/fe-common";
import ChevronDown from "@jti/rip/icons/chevron-down.svg";
import { FormattedPrice } from "@jti/ui/components/FormattedPrice";
import { Loader } from "@jti/ui-library";
import { PriceTiersContext } from "../../providers/PriceTiersContext";
import "./ProductMultiplier.scss";
const ProductMultiplierHeader = ({ handleKeyDown, toggleDropdown, }) => {
    const { selectedPriceTier } = useContext(PriceTiersContext);
    if (!selectedPriceTier) {
        return _jsx(Loader, {});
    }
    const { quantity, final_price, total_price, label } = selectedPriceTier;
    const priceToDisplay = total_price ?? final_price;
    return (_jsxs("button", { "data-testid": "product-multiplier-header", className: "product-multiplier__header", onKeyDown: handleKeyDown, onClick: toggleDropdown, children: [_jsxs("div", { className: "product-multiplier__header-title", children: [_jsxs("span", { className: "product-multiplier__header-title-label", children: [quantity, " ", label || __("product.label.packs")] }), " ", _jsxs("span", { className: "product-multiplier__header-title-label", children: ["(", _jsx(FormattedPrice, { ...priceToDisplay }), ")"] })] }), _jsx("div", { className: "product-multiplier__header-icon", children: _jsx(ChevronDown, {}) })] }));
};
export default ProductMultiplierHeader;
//# sourceMappingURL=ProductMultiplierHeader.js.map